import React from "react";

import { format } from "date-fns-tz";
import { useTranslation } from "react-i18next";

import { ContainerPosition } from "../../../../../models/marine.traffic";
import useStyles from "./styles";

interface FooterProps {
  containerPosition?: ContainerPosition;
  logo?: string;
}

export const Footer = (props: FooterProps) => {
  const { containerPosition, logo } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const openShipeeziWeb = () => {
    window.open("https://www.shipeezi.com", "blank");
  };

  return (
    <section className={classes.footerSection}>
      <div className={classes.shipeeziLink} onClick={() => openShipeeziWeb()}>
        <span>{translate("poweredBy")}</span>
        <img src={logo} className="imageLogo" />
      </div>
      <div className="footerSectionStatus">
        {containerPosition && containerPosition?.TIMESTAMP ? (
          <span>
            {translate("lastUpdated")}{" "}
            {format(new Date(containerPosition?.TIMESTAMP ?? ""), "dd/MM/yyyy")} {translate("at")}{" "}
            {format(new Date(containerPosition?.TIMESTAMP ?? ""), "p")} {translate("localTime")}
          </span>
        ) : null}
      </div>
    </section>
  );
};
